import {useEffect, useState} from "react"
import L from "leaflet";
import BlueMarker from "../assets/images/blue-marker-2x.png";
import motorIcon from "../assets/images/icons-motorcycle.png";
import Strings from "../Lang/strings";

const useTrackingMaps = (data) => {
    const initMap = (mapId, lat, long, zoom = 13, options) => {
        let map = L.map(mapId, options).setView([lat, long], zoom);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
            maxZoom: 18,
            fullscreenControl: true,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1
        }).addTo(map);
        return map;
    };

    useEffect(() => {
        initMap(
            "mini-map"
            , data.location.latitude
            , data.location.longitude,
            13,
            {
                boxZoom: false,
                zoomControl: false,
            });
        // window.
        let trackingMap = initMap(
            "tracking-map"
            , data.location.latitude
            , data.location.longitude
            , 15
            , {
                fullscreenControl: true,

            });
        const userLocationIcon = L.icon({
            iconUrl: BlueMarker,
            // shadowUrl: 'leaf-shadow.png',
            iconSize: [25, 41], // size of the icon
            shadowSize: [50, 64], // size of the shadow
            iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
            shadowAnchor: [4, 62],  // the same for the shadow
            popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
        });
        const driverLocationIcon = L.icon({
            iconUrl: motorIcon,
            // shadowUrl: 'leaf-shadow.png',
            iconSize: [30, 41], // size of the icon
            shadowSize: [50, 64], // size of the shadow
            iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
            shadowAnchor: [4, 62],  // the same for the shadow
            popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
        });

        // const userMarker =
        L.marker([data.location.latitude, data.location.longitude], {icon: userLocationIcon}).addTo(trackingMap)
            .bindPopup(Strings.yourLocation, {
                autoClose: false
            })
            .openPopup();
        if (data.driver_location) {
            // const driverMarker =
            L.marker([data.driver_location.latitude, data.driver_location.longitude], {icon: driverLocationIcon}).addTo(trackingMap)
                .bindPopup(Strings.driverLocation, {
                    autoClose: false
                })
                .openPopup()
            // let trackingMapGroup = new L.featureGroup([userMarker, driverMarker]);
            // window.trackingMap.fitBounds(trackingMapGroup.getBounds());
        }

    }, [])
}
export default useTrackingMaps;
